module.exports = __webpack_public_path__ + "fonts/opensans-regular.488406de746f43d9f0bd.ttf";